export const appConfig = Object.freeze({
  companyName: process.env.REACT_APP_COMPANY_NAME || 'Levapán',
  companyCode: 'LEVAPAN',
  appName: 'Transporte Levapán'
});
